import { validateRouteNumericParams } from '@myfunnow/web-core/route-validator'

import { NUMERIC_PARAM_KEYS } from '@/constants/pages'

export default defineNuxtRouteMiddleware(to => {
  const validationResult = validateRouteNumericParams({ routeParams: to.params, numericParamKeys: NUMERIC_PARAM_KEYS })

  if (validationResult.shouldAbort) {
    return abortNavigation()
  }
  if (validationResult.shouldRedirect) {
    return navigateTo({ name: to.name, params: validationResult.params, query: to.query, hash: to.hash })
  }
})
